import {useEffect, useState} from "react";
import {deleteScheduler, getScheduler} from "../../services/SchedulerService";
import SchdulerSingleLine from "../SchdulerSingleLine";
import {Box, Fab, Paper, Tooltip, Typography} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SchdulerNewDialog from "../SchdulerNewDialog";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const CompanyScheduler = ({company}) => {

  const [schedulerData, setSchedulerData] = useState();

  const [refetch, setRefetch] = useState(false);

  const handleDelete = (data) => {
    deleteScheduler(data.id)
        .then(() => setRefetch(prv => !prv))
        .catch(e => console.log(e));
  };

  const [newEntry, setNewEntry] = useState({
    open: false,
    data: null
  });

  const handleEdit = (data) => {
    setNewEntry({
      open: true,
      data: data
    });
  }

  const handleOpen = () => {
    setNewEntry( {
      open: true,
    });
  }

  const handleClose = () => {
    setNewEntry( {
      open: false,
    });
  };

  useEffect(() => {
    getScheduler(company.id)
        .then(res => setSchedulerData(res.data))
        .catch(e => console.log(e));
  }, [newEntry, refetch]);

  const days = [
    { key: 'SUNDAY', label: 'Sunday' },
    { key: 'MONDAY', label: 'Monday' },
    { key: 'TUESDAY', label: 'Tuesday' },
    { key: 'WEDNESDAY', label: 'Wednesday' },
    { key: 'THURSDAY', label: 'Thursday' },
    { key: 'FRIDAY', label: 'Friday' },
    { key: 'SATURDAY', label: 'Saturday' },
  ];

  const hasScheduledTasks = schedulerData && schedulerData.length > 0;

  return (
    <>
      <SchdulerNewDialog oldData={newEntry.data} open={newEntry.open} handleClose={handleClose} company={company}/>

      <Paper sx={{ mt: 3, p: 3 }} elevation={1}>
        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 3, fontWeight: 600, fontSize: "0.75rem", textTransform: "uppercase" }}>
          Weekly Schedule
        </Typography>

        {schedulerData && (
          hasScheduledTasks ? (
            <Box>
              {days.map(day => (
                <SchdulerSingleLine
                  key={day.key}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  schedulerData={schedulerData.filter(scheduler => scheduler.dayOfWeek.includes(day.key))}
                  dayOfWeek={day.label}
                />
              ))}
            </Box>
          ) : (
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 6,
              color: 'text.secondary'
            }}>
              <CalendarMonthIcon sx={{ fontSize: 48, mb: 2, opacity: 0.5 }} />
              <Typography variant="body1" fontWeight={500}>No scheduled tasks</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                Click the + button to create a new scheduled task
              </Typography>
            </Box>
          )
        )}
      </Paper>

      <Tooltip title="Add new schedule">
        <Fab
          sx={{
            position: 'fixed',
            right: 20,
            bottom: 20,
          }}
          color="primary"
          aria-label="add"
          onClick={handleOpen}
        >
          <AddIcon />
        </Fab>
      </Tooltip>
    </>
  )
};

export default CompanyScheduler;
